'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleCarousel = function () {
  function ArticleCarousel(el) {
    (0, _classCallCheck3.default)(this, ArticleCarousel);

    this.el = el;

    this.initialiseCarousel();
  }

  (0, _createClass3.default)(ArticleCarousel, [{
    key: 'initialiseCarousel',
    value: function initialiseCarousel() {
      var flkty = new _flickity2.default(this.slidesEl, {
        cellAlign: 'left',
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: false,
        touchVerticalScroll: false,
        dragThreshold: 50
      });

      flkty.on('dragStart.el', function (event, pointer) {
        document.ontouchmove = function (e) {
          e.preventDefault();
        };
      });

      flkty.on('dragEnd.flickity', function (event, pointer) {
        document.ontouchmove = function (e) {
          return true;
        };
      });

      // Setup custom buttons
      this.previousEl.addEventListener('click', function () {
        flkty.previous();
      });

      this.nextEl.addEventListener('click', function () {
        flkty.next();
      });
    }
  }, {
    key: 'previousEl',
    get: function get() {
      return (0, _functional.getElement)('[data-article-carousel-el="previous"]', {
        context: this.el
      });
    }
  }, {
    key: 'nextEl',
    get: function get() {
      return (0, _functional.getElement)('[data-article-carousel-el="next"]', { context: this.el });
    }
  }, {
    key: 'slidesEl',
    get: function get() {
      return (0, _functional.getElement)('[data-article-carousel-el="slides"]', {
        context: this.el
      });
    }
  }]);
  return ArticleCarousel;
}();

exports.default = ArticleCarousel;